var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.35 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M720 77.5h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -190.5 -20.505)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009de6",
    fillRule: "evenodd",
    d: "M725.647 77.5h-.112a1.7 1.7 0 0 0-.565.117l-.05.02c-.776.307-3.068 1.155-3.632 1.72-.843.843-1.231 1.89-1.282 3.074-.058 1.323.315 2.7.807 3.918 1.247 3.085 3.588 6.076 5.925 8.413s5.328 4.678 8.413 5.925c1.141.461 2.409.813 3.648.813q.135 0 .271-.006c1.184-.051 2.231-.439 3.073-1.281.578-.578 1.411-2.838 1.719-3.628l.019-.05a1.67 1.67 0 0 0-.72-2.064l-4.104-2.37a1.68 1.68 0 0 0-2.288.613c-.406.703-1.02 1.274-1.837 1.44a2.7 2.7 0 0 1-2.219-.498c-.912-.684-1.781-1.477-2.587-2.283-.805-.805-1.598-1.674-2.282-2.586a2.69 2.69 0 0 1-.499-2.219c.167-.816.738-1.431 1.441-1.837a1.677 1.677 0 0 0 .613-2.287l-2.37-4.105a1.66 1.66 0 0 0-1.382-.839m6.527.957a.96.96 0 0 1 .957-.957 10.87 10.87 0 0 1 10.868 10.868.956.956 0 0 1-1.634.677.96.96 0 0 1-.281-.677 8.95 8.95 0 0 0-8.953-8.953.954.954 0 0 1-.957-.958m0 3.878a.952.952 0 0 1 .957-.957 6.99 6.99 0 0 1 6.99 6.99.96.96 0 0 1-.957.95.957.957 0 0 1-.958-.95 5.077 5.077 0 0 0-5.075-5.075.95.95 0 0 1-.884-.591 1 1 0 0 1-.073-.367m0 3.878a.96.96 0 0 1 .957-.957 3.113 3.113 0 0 1 3.112 3.112.956.956 0 0 1-.958.957.956.956 0 0 1-.957-.957 1.2 1.2 0 0 0-1.197-1.198.95.95 0 0 1-.884-.59 1 1 0 0 1-.073-.367",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.27038302fc720d295a3f0e5c43010a42.svg";
export { ForwardRef as ReactComponent };